<template>
  <div class="list_message">
    <div class="top">
      <span class="name">{{record.title}}</span>
      <div class="state"><span>{{record.dockingMode}}</span></div>
    </div>
    <div class="body">
      <p class="content">
        <span class="title">日期：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span class="obj">{{record.dockingDateStr}}</span>
      </p>
      <p class="content">
        <span class="title">参与人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span class="obj">{{record.mainParticipants}}</span>
      </p>
      <p class="content">
        <span class="title">企业对接人：</span>
        <span class="obj">{{record.companyDockingUser}}</span>
      </p>
      <p class="content">
        <span class="title">参与单位：&nbsp;&nbsp;&nbsp;</span>
        <span class="obj">{{record.orgName}}</span>
      </p>
    </div>
    <div class="foot">
      <span @click="$router.push({path: '/investment/investorParticularsDetails',query:{id:record.id}})">查看详情</span>
      <img @click="$router.push({path: '/investment/investorParticularsDetails',query:{id:record.id}})" src="../../../assets/investment/jinru.png" alt="">
    </div>
  </div>
</template>

<script>

export default {
  name: "listInvestorParticulars",
  components: {},
  props: {
    record:{}
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style lang="less" scoped>
.list_message {
    background: #FFFFFF;
    padding: 12px 20px;
    border-radius: 3px;
    margin-bottom: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .04);
    word-break:break-all;
    .top{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      .name{
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        font-weight: bold;
      }
      .state{
        margin-left: 20px;
        white-space: nowrap;
        display: inline-block;
        font-size: 12px;
        line-height: 14px;
        background: rgba(34, 131, 230, 0.1);
        color: #2283E6;
        padding: 2px 4px;
        border-radius: 1px;
        span{
          display: inline-block;
          margin-top: 2px;
          transform: scale(0.8333);
        }
      }
      
    }
    .body{
      padding-top: 12px;
      border-bottom: 0.5px solid #EEEEEE;
      .content{
        margin-bottom: 12px;
        line-height: 17px;
        color: #333333;
      }
    }
    .foot{
      padding-top: 12px;
      
      span{
        display: inline-block;
        color: #36B374;
        line-height: 17px;
        font-size: 12px;
      }
      img{
        display: inline-block;
        width: 4px;
        height: 8px;
        margin-left: 5px;
      }
    }
}
</style>